import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';

import { OVERLAY_PROVIDERS } from './core/overlay';
import { UIAutoHeightDirective } from './auto-height/auto-height.directive';
import { UIBreadCrumbsComponent } from './bread-crumbs/bread-crumbs.component';
import { UICheckboxComponent } from './checkbox/checkbox.component';
import { UICollapseComponent } from './collapse/collapse.component';
import { UIDialogCloseDirective } from './dialog/dialog.directive';
import { UIDialogComponent } from './dialog/dialog.component';
import { UIDialogService } from './dialog/dialog.service';
import { UIEntriesPipe } from './pipes/entries.pipe';
import { UIInputModule } from './input/input.module';
import { UILensBeaconComponent } from './lens/beacon/beacon.component';
import { UILensComponent } from './lens/lens.component';
import { UILensPictureComponent } from './lens/picture/picture.component';
import { UILensService } from './lens/lens.service';
import { UILensTooltipComponent } from './lens/tooltip/tooltip.component';
import { UILoaderComponent } from './loader/loader.component';
import { UILoadingComponent } from './loading/loading.component';
import { UIMenuComponent } from './menu/menu.component';
import { UIMenuItemComponent } from './menu/menu-item.component';
import { UIMenuTriggerDirective } from './menu/menu-trigger.directive';
import { UIMouseWheelDirective } from './mouse/mouse-wheel.directive';
import { UIOptionComponent } from './selectbox/option.component';
import { UIPortalHostDirective } from './core/portal-directives';
import { UIProgressBarComponent } from './progress-bar/progress-bar.component';
import { UIRadioComponent } from './radio/radio.component';
import { UIRadioGroupComponent } from './radio/radio-group.component';
import { UIRouteTitleComponent } from './route-title/route-title.component';
import { UIScrollDirective } from './scroll/scroll.directive';
import { UIScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';
import { UISelectboxComponent } from './selectbox/selectbox.component';
import { UISnackBarComponent } from './snack-bar/snack-bar.component';
import { UISnackBarService } from './snack-bar/snack-bar.service';
import { UISpinnerComponent } from './spinner/spinner.component';
import { UISvgIconModule } from './svg-icon/svg-icon.module';
import { UITableComponent } from './table/table.component';
import { UIToggleComponent } from './toggle/toggle.component';
import { UITooltipDirective } from './tooltip/tooltip.directive';
import { UITooltipComponent } from './tooltip/tooltip.component';
import { SafeHtmlPipe } from 'app/core/shared/pipes/safe-html.pipe';
import { UIButtonComponent } from './button/button.component';

@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        UIInputModule,
        UISvgIconModule
    ],
    declarations: [
        SafeHtmlPipe,
        UIAutoHeightDirective,
        UIBreadCrumbsComponent,
        UICheckboxComponent,
        UICollapseComponent,
        UIDialogCloseDirective,
        UIDialogComponent,
        UIEntriesPipe,
        UILensBeaconComponent,
        UILensComponent,
        UILensPictureComponent,
        UILensTooltipComponent,
        UILoaderComponent,
        UILoadingComponent,
        UIMenuComponent,
        UIMenuItemComponent,
        UIMenuTriggerDirective,
        UIMouseWheelDirective,
        UIOptionComponent,
        UIPortalHostDirective,
        UIProgressBarComponent,
        UIRadioComponent,
        UIRadioGroupComponent,
        UIRouteTitleComponent,
        UIScrollDirective,
        UIScrollToTopComponent,
        UISelectboxComponent,
        UISnackBarComponent,
        UISpinnerComponent,
        UITableComponent,
        UIToggleComponent,
        UITooltipComponent,
        UITooltipDirective,
        UIButtonComponent
    ],
    entryComponents: [
        UIDialogComponent,
        UILensComponent,
        UISnackBarComponent,
        UITooltipComponent
    ],
    exports: [
        UIAutoHeightDirective,
        UIBreadCrumbsComponent,
        UICheckboxComponent,
        UICollapseComponent,
        UIDialogCloseDirective,
        UIDialogComponent,
        UIEntriesPipe,
        UIInputModule,
        UILensBeaconComponent,
        UILensComponent,
        UILensPictureComponent,
        UILensTooltipComponent,
        UILoaderComponent,
        UILoadingComponent,
        UIMenuComponent,
        UIMenuItemComponent,
        UIMenuTriggerDirective,
        UIMouseWheelDirective,
        UIOptionComponent,
        UIProgressBarComponent,
        UIRadioComponent,
        UIRadioGroupComponent,
        UIRouteTitleComponent,
        UIScrollDirective,
        UIScrollToTopComponent,
        UISelectboxComponent,
        UISnackBarComponent,
        UISpinnerComponent,
        UISvgIconModule,
        UITableComponent,
        UIToggleComponent,
        UITooltipComponent,
        UITooltipDirective,
        UIButtonComponent
    ],
    providers: [
        UIDialogService,
        OVERLAY_PROVIDERS,
        UISnackBarService,
        UILensService
    ]
})
export class UIModule {
}
